/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StreetVm,
    StreetVmFromJSON,
    StreetVmFromJSONTyped,
    StreetVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface StreetVmPaginatedSearchResponse
 */
export interface StreetVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<StreetVm>}
     * @memberof StreetVmPaginatedSearchResponse
     */
    items?: Array<StreetVm> | null;
    /**
     * 
     * @type {number}
     * @memberof StreetVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StreetVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof StreetVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof StreetVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StreetVmPaginatedSearchResponse
     */
    size?: number;
}

export function StreetVmPaginatedSearchResponseFromJSON(json: any): StreetVmPaginatedSearchResponse {
    return StreetVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function StreetVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreetVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(StreetVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function StreetVmPaginatedSearchResponseToJSON(value?: StreetVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(StreetVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


